module.exports = __webpack_public_path__ + "static/Ludia 1920 x 1080-93b448ff3785bf5d8497d36bac66012e.png";